//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button, TextLinkCaret } from "@vds/buttons";
import { Loader } from "@vds/loaders";
import { Notification } from "@vds/notifications";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  CVAPP_DWELLTIME,
  CVAPP_PARKINGOCCUPANCYEE,
  CVAPP_PARKINGOCCUPANCYOA,
  CVAPP_PROXIMITY,
  CV_APP_TYPE_EVENT,
  CV_APP_TYPE_EE
} from "../../../global/constants/cvappConstants";
import {
  convertToIsoFormat,
  fetchCameraCVApps,
  formatToTimeFrame,
  getCompanionidbyCamera,
  getLocationByCamera,
  getParkingCountValue,
  getTimeAbbreviation,
  updateSiteTag,
} from "../../../global/utility/Utils";
import {
  buildDeviceIdExpression,
  generateConditionString,
  getAlertEventInfo,
  getCustomerMessage,
  getCvAppCategory,
  getcvAppDetails,
  getcvAppImage,
  getcvAppTemplateValue,
  getCvAppTitle,
  getLocationHierarchyWithIds,
  getcvAppDispName
} from "../../../global/utility/cvAppUtils";
import { createRule } from "../../../model/ruleService";
import {
  fetchCountryIdsRequest,
  fetchRulesListRequest,
  resetAllRule,
  setAllTagList,
  showNotificationBanner,
  updateRuleValue,
  updateCvAppRoi
} from "../../../store/actions";
import "../../BulkRule/bulkrule.css";
import RuleReview from "./RuleReview";
import SelectAppSite from "./SelectAppSite";
import SelectROI from "./SelectROI";
import SetTrigger from "./SetTrigger";
import { CREATERULE_TEST_IDS } from "./createRuleConstants";
import moment from "moment";
import { HOUR_24_MINUTE_FORMAT } from "../../../global/constants/statistics.dateConstants";
import { useWindowSize } from "../../../global/hooks/viewportHooks";
import { getDeviceVirtualIdFromTagId } from "../../../global/utility/statisticsUtil";
import { ROUTES } from "../../../global/constants/routesConstants";

const CreateRule = () => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const tagIdList = useSelector((state) => {
    return state.sitesReducer.tagIdList;
  });
  const sitesTagList = useSelector((state) => state.sitesReducer.siteTagList);
  const tagAllLists = useSelector((state) => state?.sitesReducer.tagIdList);
  const cachedRulesList = useSelector((state) => state.alertsListReducer.rules) || [];
  const [currentFormIndex, setCurrentFormIndex] = useState(0);
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const [apiLoading, setApiLoading] = useState(false);
  const [roiParentId, setRoiParentId] = useState("");
  const [cameraId, setCameraId] = useState("");
  const [fovId, setFovId] = useState("");
  const [cvAppCondition, setCvAppCondition] = useState("");
  const [depId, setDepId] = useState("");
  const [virtualDeviceid, setVirtualDeviceId] = useState("");
  const [isParking, setIsParking] = useState(false);
  const [selectedLocationTag, setSelectedLocationTag] = useState({
    name: "",
    id: "",
  });
  const dispatch = useDispatch();
  const {
    areaSelected,
    selectedLocation,
    floorSelected,
    siteSelected,
    subAreaSelected,
    cvAppRois,
    appSelected,
    ruleName,
    roiSelected,
    triggerActions,
    isValidName,
    triggerActions: {
      customData,
      sms,
      email,
      severity,
      timeFrame,
      triggerData,
      triggerData: { addCoolDownPeriod, coolPeriodValue },
    },
    colorsSelected,
    changedParkingOccupancy,
    selAppType,
    captureVideoEvidence,
    roiImages,
  } = useSelector((state) => state.ruleReducer);
  const { cameraList, fovList } = useSelector((state) => state?.deviceReducer);
  const roiList = useSelector((state) => state.polygonRoiReducer?.roiListWithCvapps);
  const sections = [
    "Select App and Site",
    "Select Regions of Interest",
    "Set Trigger and Action",
    "Review",
  ];

  const deviceIds =
    roiSelected?.length > 1
      ? roiSelected?.map((item) => item?.deviceIds)
      : roiSelected && roiSelected[0]?.id;
  const aggregateRule =
    (selAppType === CV_APP_TYPE_EE ? false : roiSelected?.length > 1) || false;
  const foreignIds =
    roiSelected?.length > 1 && roiSelected?.map((item) => item?.foreignIds);

  const dispatchWithPromise = () => {
    return new Promise((resolve) => {
      dispatch(fetchCountryIdsRequest(resolve));
    });
  };

  useEffect(() => {
    if (!sitesTagList || !tagAllLists) {
      dispatchWithPromise().then(() => {});
    }
  }, [tagAllLists, sitesTagList]);
  const getVirtualDeviceidFun = async (cvAppRois) => {
    try {
      const cvAppImage = getcvAppImage(cvAppList, appSelected?.id);
      let selectedTagId = "";
      let selectedTagName = "";
      switch (selectedLocation) {
        case "area":
          selectedTagId = areaSelected?.id;
          selectedTagName = areaSelected?.name;
          break;
        case "sub-area":
          selectedTagId = subAreaSelected?.id;
          selectedTagName = subAreaSelected?.name;
          break;
        case "floor":
          selectedTagId = floorSelected?.id;
          selectedTagName = floorSelected?.name;
          break;
        case "site":
          selectedTagId = siteSelected?.id;
          selectedTagName = siteSelected?.name;
          break;
        default:
          selectedTagId = areaSelected?.id;
          selectedTagName = areaSelected?.name;
          break;
      }
      setSelectedLocationTag({
        id: selectedTagId,
        name: selectedTagName,
      });
      const cvappName = getcvAppDispName(cvAppList, appSelected?.id);
      const virtualTagId = getDeviceVirtualIdFromTagId(selectedTagId, cvAppRois, cvappName);
      if (!virtualTagId) {
        console.error("Unable to resolve virtual device id for tag", selectedTagId);
      }
      setVirtualDeviceId(virtualTagId);

    } catch (error) {
      console.error("Error during API call:", error);
    }
  };
  const handleNext = () => {
    if (currentFormIndex == 1) {
      getVirtualDeviceidFun(cvAppRois);
    }
    if (currentFormIndex < sections.length - 1) {
      setCurrentFormIndex(currentFormIndex + 1);
      getCameraId();
      if (changedParkingOccupancy) {
        let selectedTagId = "";
        switch (selectedLocation) {
          case "area":
            selectedTagId = areaSelected?.id;
            break;
          case "sub-area":
            selectedTagId = subAreaSelected?.id;
            break;
          case "floor":
            selectedTagId = floorSelected?.id;
            break;
          case "site":
            selectedTagId = siteSelected?.id;
            break;
        }
        handleUpdatingParkingCount(selectedTagId, changedParkingOccupancy).then(
          {}
        );
      } else if (!changedParkingOccupancy) {
        let selectedTagId = "";
        switch (selectedLocation) {
          case "area":
            selectedTagId = areaSelected?.id;
            break;
          case "sub-area":
            selectedTagId = subAreaSelected?.id;
            break;
          case "floor":
            selectedTagId = floorSelected?.id;
            break;
          case "site":
            selectedTagId = siteSelected?.id;
            break;
        }
        const defaultValue = getParkingCountValue(tagAllLists, selectedTagId);
        dispatch(
          updateRuleValue({
            propName: "changedParkingOccupancy",
            value: defaultValue,
          })
        );
      }
    } else {
      ruleCreate();
    }
  };
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];
  const result = getcvAppTemplateValue(cvAppList, appSelected?.id);

  const handleUpdatingParkingCount = async (tagid, count) => {
    const payload = {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id: tagid,
      },
      tag: {
        parkingCount: count,
      },
    };
    const result = await updateSiteTag(payload);
    if (result?.name != undefined) {
      var item = tagIdList;
      item = item.map((m) => {
        if (m.id == result?.id) {
          m = result;
        }
        return m;
      });
      dispatch(setAllTagList(item));
    } else {
      console.error("Failed to update site name");
    }
    dispatch(
      updateRuleValue({
        propName: "changedParkingOccupancy",
        value: changedParkingOccupancy,
      })
    );
  };

  useEffect(() => {
    if(cachedRulesList?.length === 0){
      dispatch(fetchRulesListRequest());
    }
  }, []);

  const handleBack = () => {
    if (currentFormIndex > 0) {
      setCurrentFormIndex(currentFormIndex - 1);
    } else if (currentFormIndex === 0) {
      navigate(ROUTES.ALERTS);
    }
  };
  const handleRoiParentId = (id) => {
    //setRoiParentId(roiSelected);
  };
  const heirarchyLocation = getLocationHierarchyWithIds(
    sitesTagList,
    selectedLocationTag?.id
  );
  useEffect(() => {
    const appCondition = getcvAppDetails(cvAppList, appSelected?.id);
    setCvAppCondition(appCondition);
  }, [appSelected]);

  const getCameraId = () => {
    let fovObject = null;

    if (roiSelected?.length > 0) {
      fovObject = fovList?.find(
        (fov) => fov?.id === roiSelected[0]?.parentdeviceid
      );
    }
    if (!fovObject) {
      return "NA";
    }
    const fovParent = fovObject?.parentdeviceid;
    setFovId(fovObject?.id);
    const cameraObject = cameraList?.find((camera) => camera?.id === fovParent);
    setCameraId(cameraObject?.id);
    return cameraObject ? cameraObject?.id : "NA";
  };

  const getDeploymentid = async () => {
    const deploymentid =
      roiSelected && roiSelected?.customData
        ? await fetchCameraCVApps(
            roiSelected && roiSelected[0]?.id,
            activeSession,
            cvAppList
          )
        : await fetchCameraCVApps(
            roiSelected && roiSelected[0]?.deviceIds,
            activeSession,
            cvAppList
          );
    setDepId(deploymentid ? deploymentid[0]?.id : "NA");
  };

  useEffect(() => {
    getDeploymentid();
  }, [roiSelected, selectedLocation]);
  const selectedColorCondition = generateConditionString(
    // cvApp === CVAPP_PPEUSAGE
    //   ? triggerData?.checkBoxData
    //   : triggerData?.selectedColors,
    colorsSelected,
    appSelected?.id,
    cvAppList,
    appSelected?.name
    // triggerData?.numberOfColors
  );

  useEffect(() => {
    if (
      appSelected?.name === CVAPP_PARKINGOCCUPANCYEE ||
      appSelected?.name === CVAPP_PARKINGOCCUPANCYOA
    ) {
      setIsParking(true);
    } else {
      setIsParking(false);
    }
  }, [appSelected]);

  const notificationInfo = {
    type: "Alert Fail",
    priority: "critical",
    showNotification: true,
  };

  const isValidFormData = (formIndex) => {
    switch (formIndex) {
      case 0:
        return siteSelected?.id && appSelected?.id && ruleName && isValidName;
      case 1:
        const hasRois = roiSelected?.length > 0;
        // Parking validation: if parking app, must have parking occupancy set
        const parkingValid = isParking ? changedParkingOccupancy > 0 : true;
        // Block Next if any selected ROI's snapshot failed to load, since the
        // user can't verify what they're selecting in that case.
        const hasFailedSelectedImage = roiSelected?.some(
          (roi) => roiImages?.[roi?.parentdeviceid] === null
        );

        if (hasFailedSelectedImage) {
          return false;
        }

        if (selectedLocation === "site") {
          return hasRois && parkingValid;
        }
        
        if (selectedLocation === "floor") {
          const floorHasRoi = floorSelected?.id && 
                  cvAppRois?.some((roi) => roi?.tagids?.includes(floorSelected?.id));
          return hasRois && floorHasRoi && parkingValid;
        }
        
        if (selectedLocation === "area") {
          return hasRois && areaSelected?.id && parkingValid;
        }
        
        if (selectedLocation === "sub-area") {
          return hasRois && subAreaSelected?.id && parkingValid;
        }
        
        // Default case for other locations
        return hasRois && parkingValid;
      case 2:
        const appCategory = getCvAppCategory(cvAppList, appSelected?.id);
        const isValid =
          triggerActions?.severity &&
          triggerActions?.customData &&
          triggerActions?.triggerData &&
          (triggerActions.sms || triggerActions.email);
        if (appCategory === "Event Apps" || appCategory === "Extra Features") {
          return isValid;
        } else if (appCategory === "Privacy Apps") {
          return isValid;
        } else if (appSelected?.name === CVAPP_DWELLTIME) {
          return (
            isValid &&
            triggerActions.triggerData.condition &&
            triggerActions.triggerData.value?.length > 0 &&
            triggerActions.triggerData.isError == false &&
            triggerActions?.triggerData?.time !== ""
          );
        } else {
          return (
            isValid &&
            triggerActions.triggerData.condition &&
            triggerActions.triggerData.value &&
            triggerActions?.triggerData?.isError == false
          );
        }
      default:
        return true;
    }
  };
  const ruleCreate = async () => {
    const groups = triggerActions?.groups
      ?.map((group) => group.label)
      .join(",");
    const showTimeFrame = timeFrame === "RB2"; // RB2 === custom timeframe
    const selectedDays = formatToTimeFrame(customData?.selectedDays);
    const startTime = convertToIsoFormat(customData?.startTime);
    const endTime = convertToIsoFormat(customData?.endTime, customData?.overNightText);
    const payloadObj = {
      activeSession,
      roiId:
        selAppType === CV_APP_TYPE_EE
          ? virtualDeviceid
          : roiSelected[0]?.id ?? roiSelected[0]?.deviceIds,
      cvAppId: roiSelected[0]?.cvapps?.[0]?.id || appSelected?.id,
      cvAppName: roiSelected[0]?.cvapps?.[0]?.name || appSelected?.name,
      severity,
      groups,
      cameraId,
      selectedDays,
      startTime,
      endTime,
      timeZone: customData?.timeZone,
      ruleName,
      sms,
      email,
      triggerData: triggerActions?.triggerData,
      showTimeFrame: showTimeFrame,
      expression: cvAppCondition,
      fovid: fovId,
      companionid: getCompanionidbyCamera(cameraList, cameraId),
      deploymentid: depId,
      cvappImage: getcvAppImage(cvAppList, appSelected?.id),
      customerMessage: getCustomerMessage(cvAppList, appSelected?.id),
      aggregateRule: aggregateRule,
      deviceIds: deviceIds,
      foreignIds: foreignIds,
      title: getCvAppTitle(cvAppList, appSelected?.id),
      eventinfo: getAlertEventInfo(
        cvAppList,
        appSelected?.id,
        selectedLocationTag?.name,
        triggerData?.value,
        triggerData?.condition,
        `${triggerActions?.triggerData?.value}${getTimeAbbreviation(
          triggerActions?.triggerData?.time
        )}`
      ),
      addUnits: appSelected?.name === CVAPP_DWELLTIME ? true : false,
      isParking: isParking,
      addCoolDownPeriod: addCoolDownPeriod,
      coolPeriodValue: addCoolDownPeriod ? coolPeriodValue : "",
      location: heirarchyLocation,
      isEventApp: selAppType == CV_APP_TYPE_EVENT ? true : false,
      captureVideoEvidence: captureVideoEvidence,
      // selectedColorCondition: selectedColorCondition,
    };
    if (isParking == true) {
      const numericTriggerValue = Number(triggerData?.value) || 0;
      const numericParkingOccupancy = Number(changedParkingOccupancy) || 0;
      payloadObj.result = Math.floor(
        (numericTriggerValue / 100) * numericParkingOccupancy
      );
    }
    if (selectedLocation === "site") {
      payloadObj.tagid = siteSelected?.id
        ? siteSelected?.id
        : getLocationByCamera(cameraId, cameraList)?.siteId;
    } else if (selectedLocation === "floor") {
      payloadObj.tagid = floorSelected?.id
        ? floorSelected?.id
        : getLocationByCamera(cameraId, cameraList)?.floorId;
    } else if (selectedLocation === "sub-area") {
      payloadObj.tagid = subAreaSelected?.id
        ? subAreaSelected?.id
        : getLocationByCamera(cameraId, cameraList)?.subAreaId;
    } else {
      payloadObj.tagid = areaSelected?.id
        ? areaSelected?.id
        : getLocationByCamera(cameraId, cameraList)?.areaId;
    }
    if (appSelected && appSelected?.name === CVAPP_DWELLTIME) {
      payloadObj.duration = `${
        triggerActions?.triggerData?.value
      }${getTimeAbbreviation(triggerActions?.triggerData?.time)}`;
    }
    if (aggregateRule === true) {
      payloadObj.globalExpression = buildDeviceIdExpression(deviceIds);
    }
    try {
      setApiLoading(true);
      const resp = await createRule(payloadObj);
      if (resp?.status !== 200 || resp?.status !== 201) {
        dispatch(showNotificationBanner(notificationInfo));
      }
      if (resp[0]?.id)
        navigate(ROUTES.ALERTS, {
          state: { create: true },
        });
        //intentionally commenting - Need discussion with Trip and team 
        //right now its object but it needs to be converted to 
        // array of object in deploy api for alert param
        // if(selAppType === "event"){
        // callDeployAPIwithAlertParam(payloadObj, resp[0]?.id);
        // }
      dispatch(fetchRulesListRequest());
    } catch (error) {
      console.log("Getting error", error);
    } finally {
      setApiLoading(false);
    }
  };

  const renderCurrentStep = () => {
    switch (currentFormIndex) {
      case 0:
        return <SelectAppSite />;
      case 1:
        return <SelectROI handleRoiParentId={handleRoiParentId} />;
      case 2:
        return <SetTrigger result={result} selAppType={selAppType} />;
      case 3:
        return <RuleReview />;
      default:
        return null;
    }
  };

  function callDeployAPIwithAlertParam(payloadObj, ruleId){
    const deployedRoi = roiList?.find((roi) => roi?.id === payloadObj?.roiId);
    const deploymentInfo = deployedRoi?.deployments?.find(
      (dep) => dep?.cvappId === payloadObj?.cvAppId && dep?.status === "deployed"
    );
    const deploymentId = deploymentInfo?.id;
     const alertParams = {};
        
          const repetatives = [];
          const precises = undefined;
          let stime = "";
          let eTime = "";
          if(payloadObj?.showTimeFrame){
          stime = new Date(payloadObj?.starttime ?? payloadObj?.startTime);
          eTime = new Date(payloadObj?.endtime ?? payloadObj?.endTime);
          repetatives.push({"days":payloadObj?.timeFrame,
                "start_time":moment(stime).format(HOUR_24_MINUTE_FORMAT),
                "end_time":moment(eTime).format(HOUR_24_MINUTE_FORMAT),
                "time_zone": payloadObj?.timeZone ?? payloadObj?.time_zone});
                
          // precises.push({"start_time": Math.floor(Date.now(stime) / 1000),
          //    "end_time":Math.floor(Date.now(eTime) / 1000)}); 
          }   
       alertParams = {"schedule":
          {
             "repetitive":repetatives,
              "precise":precises
            },
            "video_evidence_transmission_cooldown":payloadObj?.addCoolDownPeriod ? payloadObj?.coolPeriodValue : undefined,
            "ignore_video_evidence":!payloadObj?.captureVideoEvidence,
            "transmission_priority":payloadObj?.severity
        };
        
     const payloadconfigs = {
            "deploy-parameters": { },
            "alert-parameters":alertParams
          };
    const payload = {
        accountname: activeSession?.accountId,
        resourceidentifier: {
          id: deploymentId ? deploymentId : deploymentInfo?.deploymentId
        },
        deployment: {
          config: payloadconfigs
        }
      };
       dispatch(updateCvAppRoi(payload));
  }

  // Clear all rule values on component mount (page refresh)
  useEffect(() => {
    dispatch(resetAllRule());

    // reset to initial state for create rule
    return () => {
      dispatch(resetAllRule());
    };
  }, []);

  return (
    <>
      {/* --------------- Breadcrumb Scetion ---------------------- */}
      <div className="breadcrumb-and-heading">
        <div className="breadcrumb-scroll-wrapper">
        <Breadcrumbs surface="light">
          <BreadcrumbItem>
            <Link
              data-testid={CREATERULE_TEST_IDS.SETTINGS_LINK}
              to="/settings"
              className="breadcrums-item_link"
            >
              Settings
            </Link>
          </BreadcrumbItem>
            <BreadcrumbItem>
              <Link
                data-testid={CREATERULE_TEST_IDS.SETTINGS_LINK}
                to={ROUTES.ALERTS}
                className="breadcrums-item_link"
              >
                Alerts              
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>Create Alert</BreadcrumbItem>

        </Breadcrumbs>
        </div>
        <div className="rule-heading">Create Alert</div>
      </div>
      {triggerData?.isError == true &&
        !isNaN(triggerData?.value) &&
        appSelected?.name === CVAPP_PROXIMITY && (
          <Notification
            type="error"
            fullBleed={false}
            title={"Error"}
            subtitle={`The maximum distance that this app is set to detect is ${result?.default}ft. Please lower the number in the condition.`}
            disableFocus={false}
            hideCloseButton={true}
          />
        )}
      {/* ----------------- Top Progress Indicator with Nav Bar Section -------------- */}
      <div className="progress-section-container">
        <div className="bulkRule-ProgressBar-container">
          {sections.map((section, index) => (
            <div
              key={index}
              className="bulkRule-ProgressSection"
              // onClick={() => setCurrentFormIndex(index)}
            >
              <div
                className="bulkRule-TopBar"
                style={{
                  background:
                    index < currentFormIndex
                      ? "#008331"
                      : index === currentFormIndex
                      ? "#000000"
                      : "#D8DADA",
                }}
              />
              <div
                className={`bulkRule-SectionText ${
                  index === currentFormIndex ? "current" : ""
                }`}
              >
                {index + 1}. {section}
              </div>
            </div>
          ))}
        </div>
      </div>

      {apiLoading ? <Loader active fullscreen={true} disableFocusLock surface="light" /> : ""}
      <div className="bulkRule-gray-frame">
        {/* ------------------------- Main Content Section ----------------------- */}
        <div className="content-gray-container">{renderCurrentStep()}</div>

        {/* Footer Back & Next Button Section */}
        <div className="back-and-next-buttons-container">
          <TextLinkCaret
            surface="light"
            iconPosition="left"
            onClick={handleBack}
            data-testid={CREATERULE_TEST_IDS.BACK_BUTTON}

          >
            Back
          </TextLinkCaret>
          <Button
            size={width < 768 ? "small" : "large"}
            use="primary"
            onClick={handleNext}
            disabled={!isValidFormData(currentFormIndex)}
            data-testid={CREATERULE_TEST_IDS.NEXT_BUTTON}
          >
            {currentFormIndex === sections.length - 1 ? "Finish" : "Next"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreateRule;
